import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase/firebase';

let emulatorConnected = false;

function getPracticalReadingFunctions() {
  const functions = getFunctions(app, 'us-central1');
  const isLocalBrowser =
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
  const shouldUseEmulator =
    process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true' && isLocalBrowser;

  if (shouldUseEmulator && !emulatorConnected) {
    const host = process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || '127.0.0.1';
    const port = Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5001');
    connectFunctionsEmulator(functions, host, port);
    emulatorConnected = true;
  }

  return functions;
}

export async function createPracticalReadingSsoRedirect() {
  try {
    const functions = getPracticalReadingFunctions();
    const createPracticalReadingSsoToken = httpsCallable(functions, 'createPracticalReadingSsoToken');
    const result = await createPracticalReadingSsoToken({});
    return result?.data?.redirectUrl || '';
  } catch (error) {
    const code = typeof error?.code === 'string' ? error.code : '';
    const details = typeof error?.details === 'string' ? error.details : '';
    const message = typeof error?.message === 'string' ? error.message : '';
    let normalizedMessage = details || message || 'No se pudo preparar el acceso a Ejercicios Practicos.';

    if (code === 'functions/unauthenticated') {
      normalizedMessage = 'Debes iniciar sesion para acceder a Ejercicios Practicos.';
    }

    if (code === 'functions/failed-precondition') {
      normalizedMessage = 'Falta configurar el SSO de Ejercicios Practicos.';
    }

    throw new Error(normalizedMessage);
  }
}
